"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconStudyDesk = /*#__PURE__*/
function (_Icon) {
  _inherits(IconStudyDesk, _Icon);
  function IconStudyDesk(props) {
    var _this;
    _classCallCheck(this, IconStudyDesk);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconStudyDesk).call(this, props));
    _this.name = 'IconStudyDesk';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "study-desk_svg__group0"
    }, _react2.default.createElement("path", {
      className: "study-desk_svg__path0",
      d: "M22.499 24.004a.5.5 0 01-.491-.408l-1.423-7.592H3.415l-1.424 7.592a.5.5 0 01-.983-.184l1.389-7.408H1.86a1 1 0 01-.948-.682l-.667-2a1.001 1.001 0 01.949-1.317h1.575a1.983 1.983 0 01-.269-1.003c0-.575.255-1.123.682-1.5a2.004 2.004 0 01-.682-1.5c0-1.103.897-2 2-2h5l.023.001h.977a.5.5 0 010 1H10v2h.5a.5.5 0 010 1H10v2h5.551a2.52 2.52 0 011.949-1.95V4.267c0-.877-.509-1.661-1.269-2.034.494 1.266.216 2.758-.753 3.743a.498.498 0 01-.709.003l-4.242-4.243a.5.5 0 01.003-.709A3.478 3.478 0 0112.984.024c.92 0 1.783.35 2.439.988 1.705.096 3.077 1.536 3.077 3.254v5.787c.973.2 1.749.976 1.949 1.95h2.357c.268 0 .518.104.707.292a.99.99 0 01.242 1.027l-.667 1.999a.999.999 0 01-.948.683h-.538l1.389 7.408a.499.499 0 01-.492.592zm-21.307-11l.668 2.001 20.28-.001.667-1.999-21.615-.001v-.25.25zm18.222-1.001c-.209-.586-.773-1-1.414-1s-1.206.414-1.414 1h2.828zM4.5 10.002a1.001 1.001 0 000 2H9v-2H4.5zm0-3c-.551 0-1 .449-1 1s.449 1 1 1H9v-2H4.5zm10.581-2.123c.618-.964.5-2.281-.316-3.11a2.506 2.506 0 00-3.14-.347l3.456 3.457z"
    })));
    return _this;
  }
  return IconStudyDesk;
}(_Icon3.default);
exports.default = IconStudyDesk;